import { all, takeEvery, call, put } from "redux-saga/effects";
import { actionTypes as mortgageActionTypes } from "./reducer";
import { getUnitDetails, getPaymentSchemes } from "./service";

function* getUnitMeta(action) {
  const { params } = action;

  try {
    const [payload, paymentSchemes] = yield all([
      call(getUnitDetails, params),
      call(getPaymentSchemes, params)
    ]);

    yield put({
      type: mortgageActionTypes.GET_UNIT_DETAILS_SUCCESS,
      payload,
      paymentSchemes
    });
  } catch (error) {
    yield put({
      type: mortgageActionTypes.GET_UNIT_DETAILS_FAILED,
      error
    });
  }
}

function* watcher() {
  yield all([takeEvery(mortgageActionTypes.GET_UNIT_DETAILS, getUnitMeta)]);
}

export default [watcher()];
